module.exports = "https://cdn.dove.it/_next/static/public/assets/hero/diventa-agente.a64299b0f7ff75a4ba6facbbde58ca13.jpg";